import { Chip } from "@mui/material";
import styled from "styled-components";
import theme from "../../../../styles/theme";

export const ChipStyle = styled(Chip)<{
  colorText: string;
  colorBg?: string;
}>`
  && {
    width: max-content;
    height: 28px;
    background-color: ${(props) => props.colorBg ?? "#e3e1df"};

    & .MuiChip-avatar {
      width: 20px;
      height: 20px;
      color: ${(props) => props.colorText};
    }

    & span {
      font-size: 12px;
      color: ${(props) => props.colorText};
      @media ${theme.devices.tablet} {
        padding-left: 6px;
      }
    }
  }
`;
